export default "__VITE_ASSET__DL9hd3H7__"